// extracted by mini-css-extract-plugin
module.exports = {"flex":"tagModal_flex__jtfr4","button":"tagModal_button__B902O","menuContainer":"tagModal_menuContainer__GXDcz","controls":"tagModal_controls__dTHUy"};